import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFosaUser, fetchHealthFacilities, loadingUser } from "../../../action";

const FetchUser = () => {
  const dispatch = useDispatch();

  const token = localStorage.getItem("token");
  
  const userData = useSelector((state) => state.profileReducer);
 const healthFacilityId= userData?.currentUserResponseData?.i_user?.health_facility_id
 const userId = userData?.currentUserResponseData?.id;
  useEffect(() => {
    if (token) dispatch(loadingUser(token));
  }, [dispatch]);

  useEffect(() => {
    // Fetch health facilities when healthFacilityId is updated
    if (healthFacilityId) {
      dispatch(fetchHealthFacilities(healthFacilityId));
    }
    if (userId) {
      dispatch(fetchFosaUser(userId));
    }
  }, [dispatch, healthFacilityId,userId]);
  return null;
};

export default FetchUser;
